import React, { Fragment } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { Box } from 'rebass'
import IconStarFilled from '../../vectors/IconStarFilled'
import media from '../../utils/style'
import IconTrustist from '../../vectors/IconTrustist'

const ReviewsSummaryContainer = styled(Box)`
  text-align: center;
  font-weight: bold;
  text-transform: uppercase;
  display: block;
  color: ${(props) => props.theme.colors.grey_light};

  img {
    margin: 0 15px 15px;
  }
`

const ReviewsLink = styled.div`
  margin-top: 20px;

  a {
    color: ${(props) => props.theme.colors.grey_light};
  }
`

const ReviewsRatingContainer = styled.div`
  vertical-align: top;
  width: 200px;
  margin: 20px 15px 20px;

  span {
    font-size: ${(props) => rem(props.theme.fontSizes[6])};
    font-weight: normal;
  }

  ${media.MediumScreenUp`
    display: inline-block;
    margin: 0 15px;
  `}
`

const ReviewsRatingEmphasised = styled.div`
  display: inline-block;
  font-size: ${(props) => rem(props.theme.fontSizes[9])};
  line-height: 0;
  font-weight: bold;
`

const Star = styled.div`
  margin-right: 3px;
  margin-left: 3px;
  display: inline-block;
  position: relative;
  width: 15px;
  height: 15px;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }

  svg {
    width: 15px;
    height: 15px;
    line-height: 15px;

    path {
      fill: ${(props) => props.theme.colors.grey_light};
    }
  }
`

const IconStarMuted = styled(IconStarFilled)`
  opacity: 0.3;
`

const ClippedIconStar = ({ value }) => {
  const ClippedStar = styled(IconStarFilled)`
    position: absolute;
    top: 0;
    left: 0;
    clip: rect(0px, ${(props) => props.value * 15}px, 15px, 0px);
  `

  const BaseStar = styled(IconStarMuted)`
    position: absolute;
    top: 0;
    left: 0;
  `

  return (
    <Fragment>
      <BaseStar />
      <ClippedStar value={value} />
    </Fragment>
  )
}

const Stars = styled.div`
  line-height: 35px;
`

const ReviewsStars = ({ value }) => (
  <Stars>
    {Array(5)
      .fill({})
      .map((star, index) => (
        <Star key={index}>
          {index < Math.floor(value) ? (
            <IconStarFilled />
          ) : index < Math.ceil(value) ? (
            <ClippedIconStar value={value % 1} />
          ) : (
            <IconStarMuted />
          )}
        </Star>
      ))}
  </Stars>
)

const ReviewsRating = ({ value }) => (
  <ReviewsRatingContainer>
    <ReviewsRatingEmphasised>{value}</ReviewsRatingEmphasised>
    <span> / 5</span>
    <ReviewsStars value={value} />
  </ReviewsRatingContainer>
)

const ReviewsSummary = ({ average, total }) => {
  return (
    <ReviewsSummaryContainer>
      <IconTrustist />
      <ReviewsRating value={average} />
      <ReviewsLink>
        Based on{' '}
        <a href="https://www.trustist.com/customer-reviews/Website-Review-citygate-reviews-1996.html">
          {total} reviews
        </a>
      </ReviewsLink>
    </ReviewsSummaryContainer>
  )
}

export default ReviewsSummary
